import { render, staticRenderFns } from "./EmailCobrancaView.vue?vue&type=template&id=0be90a9c&scoped=true&"
import script from "./EmailCobrancaView.vue?vue&type=script&lang=js&"
export * from "./EmailCobrancaView.vue?vue&type=script&lang=js&"
import style0 from "./EmailCobrancaView.vue?vue&type=style&index=0&id=0be90a9c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be90a9c",
  null
  
)

export default component.exports